export default __webpack_public_path__ + "static/media/Shpak_Vasiliy_Viktorovich.6c8ca23a.webp";